module.exports = __webpack_public_path__ + "static/media/twitter_sm.6a619cda44d873e5e4aea5592bf75c57.svg";